/* eslint-disable no-use-before-define */
import React from 'react'
import useYieldGrid from './use-yield-grids'
import { Loading } from '../../twd'
import Footer from './footer'
import Cell from './cell'
import RatingFieldset from '../rating-fieldset'

export default () => {
    const {method, setMethod, rating, setRating, grids, status} = useYieldGrid()

    return <React.Fragment>
        <div data-name="corporates-yield-grid" style={{background:"#ffffff"}}>

        <div className="container">
        <div className="row vertical-offset-sm">

        <div className="col-md-6 col-xs-12">
            <div
                data-name="corporates-yield-grid-nav-tabs"
                className="nav-tabs">
            <ul>
                <li className={method==='HIGHEST' ? 'active' : ''}>
                <button
                    data-name="corporates-yield-grid-highest-yield-nav-tab"
                    onClick={() => setMethod('HIGHEST')}>Highest Yield</button>
                </li>

                <li className={method==='AVERAGE_10' ? 'active' : ''}>
                <button
                    data-name="corporates-yield-grid-average-yield-nav-tab"
                    onClick={() => setMethod('AVERAGE_10')}>Average Yield</button>
                </li>
            </ul>
            </div>
        </div>

        <div className="col-md-6 col-xs-12">
        <RatingFieldset
            name='corporates-yield-grid-rating'
            dataName='corporates-yield-grid-rating'
            rating={rating} setRating={setRating} />
        </div>

        </div>
        </div>

        <Loading status={status}>
            <div className="container">
            <div className="row vertical-offset-base">
            <div className="col-xs-12">
                <Grids grids={grids} />
                <Footer grids={grids} />
            </div>
            </div>
            </div>
        </Loading>

        </div>
    </React.Fragment>

}


let Grids = ({grids}) => {
    return <React.Fragment>
        { grids && grids.map( (g,i) => (
            <Grid key={i} grid={g} index={i} />
        ))}
    </React.Fragment>
}

let Grid = ({grid, index}) => {
    let w = (83.34 / (grid.columns.length - 1)).toFixed(2) + '%'

    let rs = ((grid.rows && [...grid.rows]) || [])
        .map(r => Object.assign(r, {table:grid.table, rating:grid.rating}))
    rs.shift()

    return <div className="table-responsive">
    <table data-name={`corporates-yield-grid-table-${index}`}  className="table">

    <thead>
    <tr>
        { grid.columns && grid.columns.map( (c,i) => {
            return <th key={i}
            width={i===0 ? '16.66%' : w}
            className={i===0 ? 'text-left': 'text-right'}>{i ===0 ? <h6 className="subhead" style={{marginBottom:0}}>{c}</h6> : c}</th>
        })}
    </tr>
    </thead>

    <tbody>
        {rs && rs.map((r, i) => (
            <Row key={i} row={r} />
        ))}
    </tbody>

    </table>
    </div>
}

let Row = ({row}) => {
    return <tr data-name="corporates-yield-grid-row" >
        { row.row && row.row.map( (a,i) => (
            <td key={i}
            className={i===0 ? 'text-left': 'text-right'}><Cell data={a} index={i} table={row.table} rating={row.rating} /></td>
        ))}
    </tr>
}



// WEBPACK FOOTER //
// ./src/corporates/yield-grids/yield-grids.js